// import {documentTool,fontInfo,tableInfo } from './const'
import appConfig from "@/public/globalConfig";
enum fmtType {
    fill = 0x0000,
    line = 0x1000,
    shadow = 0x2000,
    font = 0x4000, //0: color,1:background color.
    styleSet = 0x5000,
    textSet = 0x50001,
    shapeSet = 0x5002,
    lineAnimate = 0x5003,
    background = 0x8000,
    table = 0x10000,
    echart = 0x20000,
    imageSet = 0x40000,
    themeColor = 0x80000,
    defaultFont = 0x100000,
    defaultFontbg = 0x200000,
    branchFill = 0x200001,
    branchLine = 0x200002,
    mmFill = 0x200003,
    mmLine = 0x200004,
    connector = 0x200005,

    mathColor = 0x400000,

    OnceColor = 0x1000000, // 一次性颜色时使用
}
enum contextType {
    page,
    shape,
    pageBar,
    libTitle,
    libContent,
    layer,
}
export default {
    state: {
        openFileLoading: true, // 首次打开文件loading状态 true不启用切屏保存
        isFocusMode: false, // 是否开启专注模式
        focusExpand: [], // 专注模式下，上右下左展开情况
        focusShapeLoadFlag: false, // 是否加载过快速形状
        focusShapeData: [], // 快速形状数据
        isPreviewView: false, // 使用预览视图
        isFileLimitTip: false, // 是否显示文件个数限制vip提示
        isLocalFile: false, // 是否是本地文件
        isGroupView: false, // 是否打开群组文件，进入特殊视图
        isTeamFile: false, // 是否是群组文件
        isShareEditFile: false, // 是否是分享可编辑文件
        isGroupLock: true, // 群文件是否处于编辑状态
        groupRole: 1, // 群角色
        groupLockInfo: {
            nick_name: "",
            user_id: 0,
        }, // 锁定信息
        fileID: 0, // 云文件id
        fileKey: 0, // 云文件唯一key
        fileStar: 0, // 云文件星标tag
        localFilePath: "", // 本地文件路径
        urlData: "", // 封装后url search信息
        onceColor: "#FFFFFF", // 储存一次性颜色
        svgWidth: 0, // svg画布宽度
        svgHeight: 0, // svg画布高度
        Loading: false, // 点击库下载loading
        activeFunc: "", // 功能查找高亮
        loadingTextType: "library",
        ShareLoading: false, // 分享连接loading
        LoadingProcess: 0, // 加载进度条
        saveState: 0, // 保存状态：0 未保存/保存完成；1 自动保存中；2 保存中；-1 保存失败
        expandingTool: false, // 工具栏弹窗是否打开
        constScreenLeft: 298,
        sceneLeft: 298, //scene 相对于整个页面左边宽度
        sceneTop: 89, //scene 相对于整个页面上边的高度
        optionShow: false,
        sceneRight: 320, // scene 相对于整个页面右边的宽度
        sceneBottom: 35, //scene 相对于整个页面下面的高度
        sceneScrollWH: 20, //scene 的滚动条 宽高
        activeType: 0, // 右侧栏样式类型
        newActiveType: fmtType.styleSet, // 14.1.0 改版右侧样式类型
        expandStyleList: [], // 展开的样式设置 fill line shadow
        activeTabType: -1, // 菜单栏弹出类型
        loadingDone: false, //是否加载完了文件。
        isOpened: false, //是否开启了文件
        canUndo: false, // 是否可以undo.
        canRedo: false, // 是否可以redo.
        onProtectShape: false, //点击的形状是否锁定了选中

        showTabPanel: true, // 是否显示菜单面板
        showRightPanel: false, // 是否展开右侧面板
        sidePanelAnimationing: false, // 侧边（左｜右）面板展开动画ing
        currentView: "", //右侧面板类型
        hiddenRightViewList: ["echart", "layout", "tableset", "orgchart", "gantt"], // 通常不显示的右侧icon列表
        fileNameSync: "app", // 当前文件名

        showContextMenu: false, //是否显示右键菜单
        showContextExpand: false, // 是否右键菜单的扩展
        showContextExpandTimer: null, // 二级菜单定时器
        showPublish: false, // 显示发布弹窗
        showPublishSymbol: false, // 显示发布符号弹窗
        contextType: contextType, //上下文的类型
        activeContextType: null, // 当前上下文类型
        contextPos: [], // [pageX,pageY], 右键点击的位置
        currentOpePageIndex: 0, // 当前右键点击的PageBar的pageIndex.
        editingIndex: null, // 当前编辑的page的index.
        planPageCache: "", // 右侧栏平面图缓存
        lockStatus: {
            Width: false,
            Height: false,
            WHCalc: false,
            X: false,
            Y: false,
            Rotate: false,
            Begin: false,
            End: false,
            TextEdit: false,
            Format: false,
            Delete: false,
            Connector: false,
            Group: false,
            GrpFmt_Format: false,
            From_Theme: false,
            Select: false,
            // GrpFmt_Fill: false,
            // SnapOutline: false,
        }, // 锁定状态

        shareUUID: null, //分享的UUID
        shareEtag: "", //分享文件的etag
        shareOption: null, //分享的option

        editTeamOption: null, //编辑群文件的option

        isEncrypt: false, // 是否已加密
        showCryptModal: false, // 加解密窗口
        cryptType: "", // type: encry,decry,change,lift
        ignorePwd: false, // 是否免输密码
        savedPwd: "", // 首次输入时保存的密码

        fmtType: fmtType,

        couldFixWindow: false, //是够可以固定窗口。
        paletteShowAlpha: true, // 是否显示透明度设置

        fillColorWindow: false,
        lineColorWindow: false,
        fontColorWindow: false,
        fontbgColorWindow: false,

        showDropdown: false, //是否显示下拉菜单。
        dropType: null, //下拉菜单的类型
        dropTop: 0, // 下拉菜单的位置
        dropLeft: 0,
        showDropExpand: false, //是否显示下拉菜单的扩展。

        guideActiveIndex: 0, //操作指引当前idx

        showPrintContainer: false,

        activeColor: -1,
        activeColorIndex: 0,

        activeToolType: 1,
        currentColor: "#ffffff", //当前颜色 供调色板使用。

        showLibrary: false,
        showMath: false,
        showExport: false,
        showDataSheet: false,
        dataSheetHeight: 0,
        dataSheetFocus: false,
        editEChart: false,
        showPagePreviews: false,
        showPageReorder: false,
        showMap: false,
        showOptions: false,

        zoomValue: 1,
        showColorSucker: false,
        inScene: true,
        colorSuckerMatrix: [],
        colorSuckerConPos: {
            top: -1000,
            left: -1000,
        },
        showPalette: false,
        isStopPropagation: false,
        paletteInfo: {
            type: "",
            top: 0,
            left: 0,
            rightPanel: false,
        },
        //gantt 编辑
        startFlag: true, //percent、duration开始编辑
        showNumber: 0,
        editNumber: {
            value: 0,
            format: "",
        },
        editNumberAddInfo: 0,
        showDate: false,
        editDateStamp: 0,
        newDate: 0,
        dateMinus: false, //finish date
        editRect: {
            top: 0,
            left: 0,
            width: 0,
            height: 0,
        },

        // activeShapeFont: fontInfo,
        // activeTable:tableInfo | null,

        //布局编辑
        layoutData: {},
        layoutChildIdx: -1,

        //geometry修改块定位
        segPosition: [],
        //允许插入的块
        insertBlock: [],
        //特殊设置颜色序号
        specialColorIndex: -1,

        //图片编辑
        pictureInfo: {
            brightness: 0,
            contrast: 0,
            clrIndex: -1,
            transparency: 0,
            imgColor: "#ffffff",
            canClip: false,
            canRecover: false,
            canIntersect: false,
            isImage: false,
            isOrgPhoto: false,
        },
        showCompressModal: false,
        showPasteModal: false,

        showThemeType: 0,
        insertThemetype: 0,
        renameThemeID: 0,
        renameThemeName: "",
        themeColorList: [],
        //导出图片原始值

        showVipChoseDialog: false, //显示选择 vip弹窗or水印
        showMindTipsDialog: false, // 右侧点击通用主题提示
        showAIPointTipsDialog: false, // AI点数充值提示
        showAIBotDialog: false, // AI 机器人弹窗
        userShowAIBotEntry: true, // 用户主动关闭入口
        showAIBotEntry: true, // AI 机器人弹窗
        showFloatExpand: "", // 引导展开的浮动工具栏下拉窗口
        vipNextAction: "", //no之后执行函数。
        exportImageInfo: {
            pageWidth: 100,
            pageHeight: 100,
            shapeWidth: 0,
            shapeHeight: 0,
            pageShapeWidth: 100,
            pageShapeHeight: 100,
            ratio: 1,
            shapeRatio: 1,
        },

        // // 新增库
        // addLibrary: false,
        // 更新渲染库文件

        selectLibrary: [], // 0，1，2 对应 库名，表名，具体的符号
        libClickObj: [], // 储存点击的元素在ui中的index 以及前一项 本身 后一项，在数据库中的index
        selectLibraryShape: {}, // 选中的符号信息
        updateLibrary: false, // 更新表
        canMoveUpSymbol: false, // 能否上移库元素
        canMoveDownSymbol: false, // 能否下移库元素

        nolimitMath: true, // math 取消限制
        selectLayerIndex: 0,

        shareLink: "",
        shareLinkCode: "",
        shareHTML: "",
        shareData: {},
        shareType: 0,
        shareExpire: {},
        shareUseable: 0,
        shareMembers: [],
        isEChartData: false,
        isTableData: false,

        sliders: [],
        slideRatio: 1,
        activedSliderIdx: null,
        isPreviewSlide: false,
        isSlidePresented: false,

        waitCompressImgIds: [], // need compress big Image ID;
        textureImgUrl: [], // for display texture image

        canReplaceClr: false,
        canReplaceFlowClr: false,
        pageItemFillClr: [],
        pageItemLineClr: [],
        replaceFillCheck: [],
        replaceLineCheck: [],
        canUndoReplace: false,
        canRedoReplace: false,
        replaceFillWithLine: false,
        replaceFillColor: "#000000",
        replaceLineColor: "#000000",

        isElectrical: false,
        electricalCrossStyle: 0,

        // ouputimg setting
        sizeRadio: 0,
        shapeRadio: 0,
        typeRadio: 0,
        resolutionRatio: 2,
        customFontStyle: "1",
        scaleNum: 100,
        widthNum: 1344,
        heightNum: 816,
        resolutionHeight: 600,
        resolutionWidth: 600,
        unit: 0,
        marginX: 0,
        marginY: 0,
        keepScale: false,

        fileInfo: "",

        shareId: null,

        toolList: [
            "fontBtn",
            "connector",
            "colorFill",
            "colorline",
            "lineSize",
            "lineType",
            "lineAnime",
            "leftArrow",
            "rightArrow",
            "layer",
            "mirror", // 翻转
            "compose",
            "protect",
            "autoFormat",
            "pageset",
            "search",
        ], // 顶部工具栏激活按钮

        customPreferContent: null, // 用户偏好字段
        defaultFontType: 0,
        customDefaultFamily: "",
        customDefaultSize: 0,
        customDefaultBold: false,
        customDefaultItalic: false,
        customDefaultUnderline: false,
        customDefaultAlign: 0,
        customDefaultLineHeight: 0,
        customDefaultFontColor: "#000000",
        customDefaultFontColorBg: "#ffffff",

        defaultConnectorType: 0,
        customDefaultLineWidth: 0,
        customDefaultBArrow: "",
        customDefaultEArrow: "",
        customDefaultRoundSize: 0,
        customDefaultBSText: 3,
        customDefaultESText: 3,
        customDefaultLineStyle: "",
        customDefaultJumpMode: 1,
        customDefaultJumpStyle: 0,

        customDefaultConnectAnimateShowTime: 0,
        customDefaultAutoSetConnectorAnimation: false,
        customDefaultAnimeStyle: 0,
        customDefaultAnimeSpeed: 1,
        customDefaultAnimeDensity: 1,
        customDefaultAnimeColor: "#017fff",
        customDefaultAnimeDirction: 0,

        // 默认连接线样式，仅展示
        defaultLineWidth: 0.75,
        defaultBArrow: 0,
        defaultEArrow: 5,
        defaultRoundSize: 0,
        defaultBSText: 3,
        defaultESText: 3,
        defaultLineStyle: 1,

        helpTipsTour: null,
        helpTipsFlag: false,
        helpContent: {},

        album: {
            id: -1,
        },

        configList: [],
        configHost: "",
        configCache: new Map(),
        libraryLoadedStatus: 0, // 配置文件加载状态 0:waiting, 1:loading, 2:loaded
        themeLoadedStatus: 0,
        chartLoadedStatus: 0,
        textureLoadedStatus: 0,
        clipathLoadedStatus: 0,
        exportLoadedStatus: 0,
        layerContextStatus: {},
        switch: 1,
        limitFileNum: 3, // 非会员文件限制个数
        activePanel: "canvas",
        autoFormatTimes: 0,
        isEditingText: false,

        isRemarkView: false, // 是否处于编辑备注的状态
        isEdit: false, // 打开画布后是否编辑过
        showAIPanel: false,
        triggerType: "",
        seoLinkFileName: "", // SEO链接文件的文件名
        removeGrid: false, // 页面是否存在网格  true 存在 false 不存在
        saveMathSymbol: false, // 是否触发了保存公式
        showGrid: 1, // 后端返回的字段控制是否显示网格
        darkMode: false, // 是否暗黑模式，sdk 默认否
        getVipDone: false, // 获取vip状态完成
        viewLoadDone: false, // edview加载完成
        editTextOrigin: null, //主题字体更改前数据
        editLineOrigin: null, //主题链接线更改前数据
        editColorOrigin: null, //主题颜色更改前数据
        echartClickBlock: false,
        activeRightPanelKey: null, // 用于判断那个菜单有选中，如果用currentView判断，一定会展开右侧面板 x
        themeColor: "#017fff", // max 默认亮色 主题色，edraw ai 亮色暗色 主题色都是 '#7755ff' , edview 里根据这个变量值判断图元操作 辅助线、选中图元时操作点、选中框、辅助直线/斜线颜 颜色

        isSDKLimitShapeCount: false, // Edraw.AI的特殊设置，开启画布图形数量限制
    },
    getters: {
        fileKey: (state) => {
            return state.fileKey;
        },
        sceneContextPos: (state) => {
            return [state.contextPos[0] - state.sceneLeft, state.contextPos[1] - state.sceneTop];
        },
        shareUUID: (state) => {
            return state.shareUUID;
        },
        shareEtag: (state) => {
            return state.shareEtag;
        },
        editTeamOption: (state) => {
            return state.editTeamOption;
        },
        getHelpTipsTour: (state) => {
            return state.helpTipsTour;
        },
        getHelpTipsFlag: (state) => {
            return state.helpTipsFlag;
        },
        expandTop: (state) => {
            return !state.isFocusMode || (state.isFocusMode && state.focusExpand.includes(0));
        },
        expandRight: (state) => {
            return !state.isFocusMode || (state.isFocusMode && state.focusExpand.includes(1));
        },
        expandBottom: (state) => {
            return !state.isFocusMode || (state.isFocusMode && state.focusExpand.includes(2));
        },
        expandLeft: (state) => {
            return !state.isFocusMode || (state.isFocusMode && state.focusExpand.includes(3));
        },
    },
    mutations: {
        pushTextImg(state, payload) {
            state.textureImgUrl.push(payload.data);
        },
        cleanSlides(state) {
            state.sliders.splice(0, state.sliders.length);
            if (state.sliders.length == 0) {
                state.activedSliderIdx = null;
            }
        },
        changeSlide(state, payload) {
            if (payload.slide) {
                state.sliders.splice(payload.type + payload.index, payload.num, ...payload.slide);
            } else {
                state.sliders.splice(payload.type + payload.index, payload.num);
            }
            if (state.sliders.length == 0) {
                state.activedSliderIdx = null;
            }
        },
        setSlideList(state, data) {
            state.sliders.splice(0, state.sliders.length);
            state.sliders = data;
        },
        swap2Slide(state, payload) {
            state.sliders.splice(payload.index, 0, state.sliders.splice(payload.pIndex, 1).pop());
        },
        closeContext(state) {
            state.showContextMenu = false;
            state.showContextExpand = false;
            state.activeContextType = null;
        },
        closeDrop(state) {
            state.showDropdown = false;
            state.showDropExpand = false;
        },
        toShow(state, payload) {
            state[payload.type] = payload.data;
        },
        setColor(state, payload) {
            state.activeColor = payload.type;
            state.activeColorIndex = payload.index;
        },
        setStatus(state, payload) {
            if (payload.type === "shareLink") {
                let isTest = location.host.includes("dev.edrawmax");
                if (isTest) {
                    payload.data = payload.data.replace("www.edrawmax", "dev.edrawmax");
                }
                if (process.env.NODE_ENV !== "production") {
                    let code = payload.data.split("?")[1];
                    payload.data = `${location.host}/share.html?${code}`;
                }
            }
            state[payload.type] = payload.data;
            if (payload.type === "showLibrary") {
                if (payload.data) {
                    state.sceneLeft = state.constScreenLeft;
                } else {
                    state.sceneLeft = 0;
                }
            }
        },
        toPalette(state, payload) {
            state.paletteInfo.type = payload.type;
            state.paletteInfo.top = payload.top;
            state.paletteInfo.left = payload.left;
            state.paletteInfo.rightPanel = payload.rightPanel;
        },
        initLayout(state, object) {
            state.layoutData = object;
        },
        setLayoutChild(state, payload) {
            state.layoutChildIdx = payload.idx;
        },
        setPictureState(state, payload) {
            state.pictureInfo = payload;
        },
    },
    actions: {
        usePalette({ commit }, payload) {
            let top, left;
            if (payload.custom) {
                top = payload.top;
                left = payload.left;
            } else {
                let e = payload.e;
                let pageLeft = e.pageX;
                let pageTop = e.pageY;
                top = pageTop + e.target.offsetHeight - e.offsetY;
                left = pageLeft - e.offsetX;
                if (payload.newTopLeft) {
                    top = top + payload.newTopLeft.top;
                    left = left + payload.newTopLeft.left;
                }

                if (window.innerHeight - top < 327) {
                    top = top - (top + 327 - window.innerHeight);
                }
            }
            // do {
            //     top += node.offsetTop - node.scrollTop;
            //     left += node.offsetLeft;
            //     node = node.offsetParent;
            // } while (node !== null);
            commit("toPalette", {
                type: payload.type,
                top,
                left,
                rightPanel: payload.rightPanel,
            });
            commit("setStatus", {
                type: "showPalette",
                data: true,
            });
            console.log(`top:${top},left:${left}`);
            console.log(payload.type);
        },
        loadConfig({ state }, arr) {
            let worker = new Worker(appConfig.workerURL);
            let promise = null;
            let saveLocalConfigList = (data) => {
                if (window.localStorage) {
                    let list = window.localStorage.getItem("configList")
                        ? window.localStorage
                              .getItem("configList")
                              .split(",")
                              .map((v) => +v)
                        : [];
                    data = list.concat(data);
                    window.localStorage.setItem("configList", data.toString());
                }
            };
            let getLocalConfigList = () => {
                if (window.localStorage) {
                    return (
                        window.localStorage
                            .getItem("configList")
                            .split(",")
                            .map((v) => +v) || []
                    );
                }
            };
            let checkLocalConfig = () => {
                // 检测本地是否有配置文件
                let list = state.configList;
                let localList = getLocalConfigList();
                let filterList = [];
                for (let i = 0; i < arr.length; i++) {
                    for (let j = 0; j < list.length; j++) {
                        if (list[j].name == arr[i]) {
                            if (localList.indexOf(list[j].id) == -1) {
                                filterList.push(arr[i]);
                            }
                        }
                    }
                }
                arr = filterList;
                return arr.length > 0;
            };
            promise = state.configCache.get(arr.join("-"));
            if (promise) {
                return promise;
            }
            promise = new Promise((workerRes, workerRej) => {
                if (false && !checkLocalConfig()) {
                    console.log("local config exist");
                    workerRes();
                } else {
                    // console.log('download config')
                    let host = state.configHost;
                    let axiosData = [];
                    for (let i = 0; i < arr.length; i++) {
                        for (let k = 0; k < state.configList.length; k++) {
                            if (state.configList[k].name == arr[i]) {
                                axiosData.push(state.configList[k]);
                                break;
                            }
                        }
                    }

                    if (axiosData.length) {
                        let newArr = [];
                        let updateArr = [];

                        let opendb = window.indexedDB.open("versionDB");
                        opendb.onsuccess = (e) => {
                            let db = opendb.result;
                            let trans = db.transaction("configVersion", "readwrite");
                            let objstore = trans.objectStore("configVersion");
                            let index = objstore.index("configIDIndex");
                            let configList = [];

                            let promiseArr = [];
                            for (let i = 0; i < axiosData.length; ++i) {
                                if (axiosData[i].name == "groupMenu") {
                                    // 针对符号库菜单特殊处理
                                    configList.push(axiosData[i].id);
                                    this.libVersionObj = {
                                        configName: "menuList",
                                        configID: axiosData[i].id,
                                        version: axiosData[i].version,
                                    };
                                    promiseArr.push(
                                        new Promise((res, rej) => {
                                            index.get(axiosData[i].id).onsuccess = (e) => {
                                                let data = (e.target as IDBRequest).result;
                                                this.libFlag = true; // 需要更新
                                                if (data) {
                                                    if (data.version == axiosData[i].version) {
                                                        this.libFlag = false;
                                                    }
                                                }
                                                res();
                                            };
                                        })
                                    );
                                } else if (axiosData[i].name == "OrgFields_en.xml") {
                                    configList.push(axiosData[i].id);
                                    let versionObj = {
                                        configName: "orgchartField",
                                        configID: axiosData[i].id,
                                        version: axiosData[i].version,
                                    };
                                    promiseArr.push(
                                        new Promise((res, rej) => {
                                            index.get(axiosData[i].id).onsuccess = (e) => {
                                                let data = (e.target as IDBRequest).result;
                                                if (data) {
                                                    // 有数据且版本不一致 需要更新
                                                    if (data.version !== axiosData[i].version) {
                                                        this.saveOrgField(`${host}/${axiosData[i].url}`, versionObj).then((e) => {
                                                            res();
                                                        });
                                                    } else {
                                                        res();
                                                    }
                                                } else {
                                                    this.saveOrgField(`${host}/${axiosData[i].url}`, versionObj).then((e) => {
                                                        res();
                                                    });
                                                }
                                            };
                                        })
                                    );
                                } else if (
                                    [
                                        "ThemeXml.tar",
                                        "ClipPath.tar",
                                        "ExpXml4Office.tar",
                                        "markData.tar",
                                        "mmThemes.tar",
                                        "texture.tar",
                                        "shapeStringXML.tar",
                                        "EChartsData.tar",
                                    ].includes(axiosData[i].name)
                                ) {
                                    configList.push(axiosData[i].id);
                                    promiseArr.push(
                                        new Promise((res, rej) => {
                                            index.get(axiosData[i].id).onsuccess = (e) => {
                                                let data = (e.target as IDBRequest).result;
                                                if (data) {
                                                    // 有数据且版本不一致 需要更新
                                                    if (data.version !== axiosData[i].version) updateArr.push(axiosData[i]);
                                                } else {
                                                    newArr.push(axiosData[i]);
                                                }
                                                res();
                                            };
                                        })
                                    );
                                }
                            }
                            Promise.all(promiseArr).then((e) => {
                                if (newArr.length > 0 || updateArr.length > 0) {
                                    let downloadArr = newArr.concat(updateArr).map((v, k) => {
                                        return {
                                            name: v.name,
                                            type: v.type,
                                            v: 1,
                                            url: `${host}/${v.url}`,
                                            dataVersionInfo: {
                                                configName: v.name,
                                                configID: v.id,
                                                version: v.version,
                                            },
                                        };
                                    });

                                    let obj = {};
                                    for (let i = 0; i < downloadArr.length; ++i) {
                                        obj[downloadArr[i]["name"].match(/[a-zA-Z].[^\.]*/)] = downloadArr[i];
                                    }
                                    worker.postMessage({
                                        type: "checkDB",
                                        data: obj,
                                    });
                                    worker.onmessage = (e) => {
                                        let message = e.data;
                                        if (message.type === "loaded") {
                                            saveLocalConfigList(configList);
                                            workerRes();
                                            worker.terminate();
                                            db.close();
                                        }
                                    };
                                } else {
                                    workerRes();
                                    worker.terminate();
                                    db.close();
                                }
                            });
                        };
                    }
                }
            });
            state.configCache.set(arr.join("-"), promise);
            return promise;
        },
    },
};
